export default __webpack_public_path__ + "static/media/youtube_light_purple.a6679594.svg";